import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { LayoutOffset } from '../../../core/types/layout';
import { commonGapClass, commonPaddingClass } from '../../../core/utilities/layout';

@Component({
    selector: 'app-grid-container',
    templateUrl: './grid-container.component.html',
    styleUrls: ['./grid-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GridContainerComponent {

  @Input() public columns?: number;
  @Input() public rows?: number;
  @Input() public gap?: LayoutOffset = 'sm';
  @Input() public hasHeader?: boolean = false;

  @HostBinding('style.grid-template-columns')
  protected get gridTemplateColumns(): string {
    return `repeat(${this.columns ?? 0}, 1fr)`;
  }

  @HostBinding('style.grid-template-rows')
  protected get gridTemplateRows(): string {
    if (this.hasHeader) {
      return `var(--grid-header-height) repeat(${(this.rows ?? 0) - 1}, 1fr)`;
    } else {
      return `repeat(${this.rows ?? 0}, 1fr)`;
    }
  }

  @HostBinding('style.--grid-has-header-top')
  protected get gridTemplateGridHasTop(): number | undefined {
    return this.hasHeader ? undefined : 0;
  }

  @HostBinding('class')
  protected get offsetClasses() {
    return `${commonPaddingClass(this.gap)} ${commonGapClass(this.gap)}`;
  }

}
